import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/demo.vue";
import ChangeTime from "./ChangeTime/ChangeTime.vue";

export default {
    name: "BatteryAnalysis",
    components: {
        tree,
        iTable,
        IPagination,
        ChangeTime
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            batteryNumber: '',
            number: '',
            isSearch: true,
            activeName: 'first',
            orgId: '',
            height: '320',
            list: [], 
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                height: false,
                mutiSelect: false,
                serialNumber: false,
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('BatteryAnalysis.carId'),
                    align: "center",
                },
                {
                    prop: "batteryNumber",
                    label: this.$t('BatteryAnalysis.batteryNumber'),
                    align: "center",
                },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10, 
            total: 1, 
        };
    },
    mounted() {

    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        onkeyUp() {
            this.currentPage = 1
            this.pageSize = 10
            this.queryCarMaintain()
        },
        queryCarMaintain() {
            this.tableLoading = true
            let param = {
                orgId: Number(this.orgId),
                pageSize: this.pageSize,
                pageNum: this.currentPage,
                number: this.number,
            };
            this.$store.dispatch('BatteryAnalysis/GET_SELECTBATTERYPAGE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list;
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
                this.tableLoading = false
            }).catch(err => { this.tableLoading = false })
        },
        initQuery(item) {
            this.orgId = item.id
            this.queryCarMaintain()
            this.$refs.changeTime.orgId = this.orgId
            this.$refs.changeTime.batteryNumber = ''
            this.$refs.changeTime.getcarCompare()
            this.$refs.changeTime.initQuery('all')
        },
        nodeClick(val) {
            this.orgId = val.label
            this.queryCarMaintain()
            this.$refs.changeTime.orgId = val.label
            this.$refs.changeTime.batteryNumber = ''
            this.$refs.changeTime.getcarCompare()
            this.$refs.changeTime.initQuery('all')
        },
        rowClick(row) {
            console.log(row)
            this.batteryNumber = row.batteryNumber
            this.$refs.changeTime.batteryNumber = row.batteryNumber
            this.$refs.changeTime.getcarCompare()
            this.$refs.changeTime.isShow = false
            this.$refs.changeTime.initQuery('one')
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.queryCarMaintain();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    },
};
